import { render } from "./AccountsView.vue?vue&type=template&id=2bc88eb0&ts=true"
import script from "./AccountsView.vue?vue&type=script&lang=ts"
export * from "./AccountsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__